import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Issued Passes</Typography>
      <p>This table shows all your issued passes. If you have a lot of passes, it may take
        a while to finish loading since it will load them in stages.
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Table features</Typography>
      <p>Like all our tables, you can search and filter data, download the content to JSON, CSV
        or MS Excel.
      </p>

      <p>You'll notice a toggle button where you can swap between live and test passes. You can
        force a refresh (you may have issued more passes via the API since you loaded the page which you'd 
        like to see incldued).
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Notify selected passes</Typography>
      <p>You can send a notification (message) to a selection of passes. Just tick the box next to the 
        passes you want to include then hit the [notify selected passes] button.
      </p>

      <Typography variant='h5' className='pt-10 pb-5'>Table content</Typography>
      <p>The content of the table depends upon the type of pass. Most fields are common, a few are specific to
        a pass type.

        <ul>
          <li><b>Pass ID</b> : Every pass issued for a templare must have a unique ID. This is the ID associated with this pass.</li>
          <li><b>Pass Key</b> : This forms part of the URL you will distribute for your customers to download Apple passes. This prevents 
          a malicious user from simply trying various pass ID to access passes. They need to specific key for each pass. We take car of this 
          for you, so don't worry about it, it is her efor completeness only.</li>
          <li><b>Grouping ID</b> : When you issue multiple passes to a customer you might liek to group them together. If so you'll
          specify a groupin ID in your pass data. This is that ID. It is optional and can be ignored if grouping is not applicable to you.</li>
          <li><b>Status</b> : Expired - the expiry date you set has passed. Current - Not expired (or no expiry date set) </li>
          <li><b>Expiry date</b> : Expiry date (if set)</li>
          <li><b>Apple devices</b> : Number of Apple devices this pass is installed on</li>
          <li><b>Google devices</b> : Number of Google devices this pass is installed on</li>
          <li><b>Sync required</b> : Indicates if this pass is out of sync with changes you may have made to the template</li>
          <li><b>Created</b> : Date / time the pass was issued</li>
        </ul>
      </p>

    </div>
  )
}

export default HelpText